export { learningActivityImagePath, ckeEditorToolBarOptions } from './commonConstants';